/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import useReportsProcessing from './hooks/useReportsProcessing';
import ReportsProcessingPrompt from './ReportsProcessingPrompt';

/**
 * @internal
 *
 * Defines the `ReportsProcessing` component which is responsible for managing the
 * display of the `ReportsProcessingPrompt` notification based on the value of the
 * `processingComplete` sisense option for the current account. When the value is
 * `false`, the prompt is to be displayed, otherwise, the prompt will be omitted.
 */
const ReportsProcessing = () => {
  const [isProcessing, trigger] = useReportsProcessing();
  const [showPrompt, setShowPrompt] = useState(isProcessing);

  useEffect(() => {
    setShowPrompt(isProcessing);
  }, [isProcessing, trigger]);

  const onClose = useCallback(() => {
    setShowPrompt(false);
  }, []);

  if (showPrompt) {
    return <ReportsProcessingPrompt onClose={onClose} />;
  }
  return undefined;
};
export default ReportsProcessing;
